// extracted by mini-css-extract-plugin
export default {"active":"CustomHeader_active__Wmk-H","pending":"CustomHeader_pending__kox7t","backArrow":"CustomHeader_backArrow__uAfT7"};